export { default as withClickAnalytic } from './withClickAnalytic';



// WEBPACK FOOTER //
// ./packages/platform-utils/analytics/hoc/index.ts